// removed by extract-text-webpack-plugin
module.exports = {"button":"_2123BdtQ6rqnP6lfTVtn88","subtitle":"_2Panac-cHZP9QYwExMCrtq","forgot":"_2dMKmWV-yMdDQIetO8D4pd"};


//////////////////
// WEBPACK FOOTER
// ./src/Pages/SignInPage/SignInPage.css
// module id = 651
// module chunks = 3